<template>
    <div>
        <textarea :id="'summernote_'+this.textareaId" v-model="value" class="summernote"></textarea>

        <input :id="name" v-model="value" :name="name" type="hidden">
    </div>
</template>

<script>

import "summernote/dist/summernote.css";
import "summernote";

export default {
    props: {
        initialValue: {
            type: String,
            required: false,
            default: ''
        },
        placeholder: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            value: 'NOn no no non ono',
            textareaId: Date.now() + Math.floor((Math.random() * 100) + 1)
        }
    },
    methods: {
        uploadImageContent(image, editorInstance) {

            let data = new FormData();
            data.append("image", image);

            this.$loading(true);
            axios.post("/api/editor/upload-image",
                data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(data => {
                    console.log(data.data)
                    let image = $('<img>').attr('src', data.data);
                    $(editorInstance).summernote("insertNode", image[0]);
                })
                .catch(error => {

                    this.$awn.alert(error);
                })
                .then(() => {

                    this.$loading(false);
                });
        }
    },
    mounted() {
        const vm = this;
        this.value = this.initialValue;

        const options = {
            lang: 'en-US',
            dialogsInBody: true,
            fontName: 'Arial',
            fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New'],
            fontSizeUnits: ['px'],
            lineHeights: ['0.2', '0.3', '0.4', '0.5', '0.6', '0.8', '1.0', '1.2', '1.4', '1.5', '2.0', '3.0'],
            fontSize: 14,
            minHeight: 120,
            placeholder: this.placeholder,
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontname', 'fontsize', 'color', 'bold', 'italic', 'underline', 'strikethrough', 'clear']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'elfinder']],
                ['view', ['codeview', 'help']],
            ],
        };

        let editorInstance = 'textarea#summernote_' + vm.textareaId;

        options.callbacks = {
            onInit: function () {
                $(vm.$el).summernote("code", vm.initialValue);
            },
            /*onChange(contents) {
                vm.$emit('returnHtml', contents, vm.input)
            },*/
            onImageUpload: function (image) {

                vm.uploadImageContent(image[0], editorInstance);
            }
        };

        //$(editorInstance).summernote(options);

        $('.note-editor .note-editable').css("line-height", 1);

    }
}
</script>

<style scoped>
p {
    line-height: 1;
}

.note-editor .note-editable {
    line-height: 1;
}

.note-editor .note-toolbar .note-dropdown-menu.note-check a i {
    visibility: visible !important;
}
</style>
